module.exports = __webpack_public_path__ + "img/迪林.d20226b1.jpg";